import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import { fileSearchQueryOptions } from "@/lib/data/react-query/files/search-files";
import type { FileSearchScope } from "@/lib/data/schemas/files";

export const useFileSearch = (
  text: string,
  scope: FileSearchScope,
  enabled = true,
) => {
  const q = text.trim();
  const debouncedQuery = useDebouncedValue(q, 300);
  const isDebouncing = q !== debouncedQuery;
  const query = useInfiniteQuery(
    fileSearchQueryOptions(
      { ...scope, q: debouncedQuery },
      enabled && q.length >= 2 && !isDebouncing,
    ),
  );
  const hits = useMemo(
    () => query.data?.pages.flatMap((page) => page.data) ?? [],
    [query.data],
  );
  return { ...query, hits, isDebouncing, isTooShort: q.length < 2 };
};
